import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';

var DetailsSection = function DetailsSection() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx("section", {
    className: "py-8 bg-white border-b",
    children: /*#__PURE__*/_jsxs("div", {
      className: "container mx-auto max-w-7xl",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex flex-wrap",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex flex-col justify-center p-6 sm:w-1/2",
          children: [/*#__PURE__*/_jsx("h3", {
            className: "mb-3 text-3xl font-bold leading-none text-gray-800",
            children: t('landing.trustedByDeveloppersAndCustomers')
          }), /*#__PURE__*/_jsx("p", {
            className: "text-gray-600 md:text-xl",
            children: t('landing.trustedByDeveloppersAndCustomersDescription')
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "w-full p-6 sm:w-1/2",
          children: /*#__PURE__*/_jsx("div", {
            className: "",
            children: /*#__PURE__*/_jsx(Image, {
              src: "https://kreezus.com/wp-content/uploads/2022/05/privacy-beb60ae3d6b48c5a83f283349ccbc439.png",
              alt: "privacy",
              width: 500,
              height: 500,
              layout: "responsive"
            })
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col-reverse flex-wrap sm:flex-row",
        children: [/*#__PURE__*/_jsx("div", {
          className: "w-full p-6 sm:w-1/2",
          children: /*#__PURE__*/_jsx(Image, {
            src: "https://kreezus.com/wp-content/uploads/2022/05/test1.png",
            alt: "addons",
            layout: "responsive",
            width: 500,
            height: 500
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "flex flex-col justify-center w-full p-6 sm:w-1/2",
          children: /*#__PURE__*/_jsxs("div", {
            className: "align-middle",
            children: [/*#__PURE__*/_jsx("h3", {
              className: "mb-3 text-3xl font-bold leading-none text-gray-800",
              children: t('landing.integrationFuture.title')
            }), /*#__PURE__*/_jsx("p", {
              className: "text-gray-600 md:text-xl",
              children: t('landing.integrationFuture.description')
            })]
          })
        })]
      })]
    })
  });
};

export default DetailsSection;